module.exports = __webpack_public_path__ + "img/linkedin.75fde704.svg";